import FetchHelpers from '../../../utils/FetchHelpers';
import formUrl from '../../../utils/routes';
import { decamelize } from '../../../utils/keysConverter';

export default {
  load(fastCashId) {
    const url = formUrl(
      `/api/v1/admin/fast_cash/${fastCashId}/special_cashback_rates`
    );
    return FetchHelpers.get(url);
  },
  create(fastcashId, params) {
    const url = formUrl(
      `/api/v1/admin/fast_cash/${fastcashId}/special_cashback_rates`
    );
    return FetchHelpers.post(url, decamelize(params));
  },
  delete(fastcashId, specialCashbackRateId) {
    const url = formUrl(
      `/api/v1/admin/fast_cash/${fastcashId}/special_cashback_rates/${specialCashbackRateId}`
    );
    return FetchHelpers.delete(url);
  },
};
